/**
 * Main JavaScript File
 * 
 * @package KateMedia
 */

import { initPreloader } from './modules/preloader.js';
import { initSwiper } from './modules/swiper-init.js';
import { initMobileMenu } from './modules/mobile-menu.js';
import { initSmoothScroll } from './modules/smooth-scroll.js';
import { initForms } from './modules/forms.js';
import { initAnimations } from './modules/animations.js';
import { initFixedHeader } from './modules/fixed-header.js';
import { initTooltips } from './modules/tooltips.js';
import { initMarquee } from './modules/marquee.js';
import { initToggleSwitch } from './modules/toggle-switch.js';
import { initFaqAccordion } from './modules/faq-accordion.js';
import { initAutomizationSlider } from './modules/automization-slider.js';
import { initContactPopupModule } from './modules/contact-popup.js';
import { initCf7Redirect } from './modules/cf7-redirect.js';
import { domReady } from './modules/utils.js';

(function() {
    'use strict';

    function initApp() {
        try {
            initPreloader();
            initSwiper();
            initMobileMenu();
            initSmoothScroll();
            initForms();
            initAnimations();
            initFixedHeader();
            initTooltips();
            initMarquee();
            initToggleSwitch();
            initFaqAccordion();
            initAutomizationSlider();
            initContactPopupModule();
            initCf7Redirect();
        } catch (error) {
            console.error('Error initializing modules:', error);
        }
    }

    domReady(() => {
        initApp();
    });

})();
